<template>
  <div class="md:flex justify-center my-10 md:px-32 sm:px-12 lg:px-64">
    <div class="w-full">
      <!-- <pre>   {{request_type}}</pre> -->
      <div>
        <BackButton @back="onPressBack('Request/Inquiry')" />
      </div>
      <hr class="bg-gray-500 my-2 w-full h-1" />
      <v-card>
        <v-card-title primary-title>
          <div class="font-light text-lg">Choose from below items:</div>
        </v-card-title>
        <div class="bg-gray-200 p-4">
          <div v-for="(item, i) in request_type" :key="i" class="w-full my-2">
            <v-btn
              v-if="item.request_type_id != 6 && item.request_type_id == 5"
              @click="onPress(item)"
              text
              color="rgb(152, 4, 4)"
              class="w-full flex justify-start py-2 text-left"
            >
              {{ item.request_type }}
            </v-btn>

            <v-btn
              v-else-if="item.request_type_id == 9"
              text
              disabled
              color="rgb(152, 4, 4)"
              class="w-full flex justify-start py-2 text-left"
              @click="submitTicket"
            >
              {{ item.request_type }}</v-btn
            >
            <v-btn
              disabled
              v-else
              text
              color="rgb(152, 4, 4)"
              class="w-full flex justify-start py-2 text-left"
            >
              {{ item.request_type }}
            </v-btn>
          </div>
        </div>
      </v-card>

      <!-- alert  -->
      <AlertDialog
        :props_data="props_data"
        :showAlert="showAlert"
        @alertDialogSubmit="alertDialogSubmit"
      />
    </div>
  </div>
</template>

<script>
import AlertDialog from "../../common/AlertDialog.vue";

import BackButton from "../../common/BackButton.vue";
import axios from "axios";
export default {
  data() {
    return {
      showAlert: false,
      request_type: [],
    };
  },
  components: { AlertDialog, BackButton },
  watch: {
    "$route.path": {
      handler(e) {
        if (e) {
          this.getRequestType();
        }
      },
      immediate: true,
    },
  },
  methods: {
    alertDialogSubmit(name) {
      this.showAlert = false;
      !this.$route.path.includes(name) ? this.$router.push(name) : null;
    },
    submitTicket() {
      this.showAlert = true;
      this.props_data = {
        status_id: 1,
        remarks_id: 1,
        classification_id: this.$route.meta.classification_id,
        request_type_id: this.$route.meta.request_type_id,
        department_id: 10,
        subject: this.$route.meta.subject,
      };
    },
    onPressBack(e) {
      this.$router.push({ name: e });
    },
    getRequestType() {
      axios.get("/request_type").then((res) => {
        this.request_type = res.data.filter((x) => x.request_type_id != 2);
      });
    },
    onPress(selected) {
      if (!this.$route.path.includes(selected.path_name)) {
        this.$router.push({
          name: selected.path_name,
          params: {
            request_type_id: selected.request_type_id,
            classification_id: selected.classification_id,
            subject: selected.request_type,
          },
        });
      }
    },
  },
};
</script>
